/* global _ */

import api from './api';

const { noop } = _;

export default function( callback ) {
	callback = callback || noop;

	api( 'innoway/v2/categories', {}, response => {
		callback( response.data || [] );
	} );
}
